import dateFns from 'date-fns';

export const getTokenExpiry = ({ exp }) => new Date(exp * 1000);
export const hasTokenExpired = (token) => dateFns.isBefore(getTokenExpiry(token), new Date());



// WEBPACK FOOTER //
// ./src/common/jwt-token.js